var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-sans antialiased flex flex-col",attrs:{"id":"app"}},[(!_vm.loading)?_c('router-view',{key:JSON.stringify(_vm.$route.params)}):_c('Loading',{staticClass:"h-screen"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }